import { useState, useEffect } from 'react'
import { apiGet } from '../../generic/Api_Functions'
import useAuthorization from '../../generic/hooks/useAuthorization/useAuthorization'

const DASHBOARD_CUSTOMIZED = 'DASHBOARD_CUSTOMIZED'

/**
 * S21 / CA7 — active proxied services to render as dynamic dashboard menu items.
 * Fetched from the non-backoffice consumption endpoint (reduced DTO: name + prefix) and only for
 * users with the DASHBOARD_CUSTOMIZED permission. On error or no permission it yields an empty
 * list so the left menu never breaks.
 *
 * @returns {{ name: string, prefix: string }[]}
 */
const useProxiedServicesMenuItems = () => {
  const isUserAuthorized = useAuthorization()
  const canConsume = isUserAuthorized(DASHBOARD_CUSTOMIZED)
  const [proxiedServices, setProxiedServices] = useState([])

  useEffect(() => {
    if (!canConsume) {
      setProxiedServices([])
      return
    }
    let active = true
    const fetchProxiedServices = async () => {
      try {
        const services = await apiGet('proxied-services')
        if (active) setProxiedServices(Array.isArray(services) ? services : [])
      } catch (error) {
        if (active) setProxiedServices([])
      }
    }
    fetchProxiedServices()
    return () => { active = false }
  }, [canConsume])

  return proxiedServices
}

export default useProxiedServicesMenuItems
